<template>
  <div class="feng-tuoyuan-activity">
    <div class="success-main">
      <div class="page-header">
        <img class="brand-logo" src="/static/images/fty/logo.png" alt="丰驼源 logo">
      </div>
      <div class="result-card-placeholder"></div>
    </div>

    <div class="success-actions">
      <div class="primary-action" @click="goActivity">
        <img class="primary-action-img" src="/static/images/fty/lqjf.png" alt="领取积分参与活动">
      </div>

      <div class="bottom-actions">
        <div class="bottom-action" @click="goTrace">
          <img class="bottom-action-img" src="/static/images/fty/query-sy.png" alt="查看溯源信息">
        </div>
        <div class="bottom-action">
          <img class="bottom-action-img" src="/static/images/fty/white-go-shop.png" alt="进入官方商城">
        </div>
      </div>
    </div>

    <div v-if="showRewardModal" class="reward-modal-mask">
      <div class="reward-modal-card">
        <div class="reward-modal-tip">{{ rewardModalTip }}</div>

        <div class="reward-modal-icon-wrap">
          <img class="reward-modal-icon" :src="rewardModalIcon" alt="积分图标">
        </div>

        <div class="reward-modal-title">{{ rewardModalTitle }}</div>

        <div class="reward-modal-info">
          <div class="reward-modal-info-row">
            <span class="reward-modal-info-label">产品名称：</span>
            <span class="reward-modal-info-value">{{ productName }}</span>
          </div>
          <div class="reward-modal-info-row">
            <span class="reward-modal-info-label">产品型号：</span>
            <span class="reward-modal-info-value">{{ productModel }}</span>
          </div>
        </div>

        <wx-open-launch-weapp
          class="reward-modal-shop-entry"
          :appid="miniAppId"
          :username="miniAppOriginalId"
          :path="miniAppPage"
        >
          <script type="text/wxtag-template">
            <img
              src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/qwsc-blue-1c0f6e973f02445e8e0731fa809d96e3.png"
              alt="前往商城"
              style="display:block;width:100%;height:auto;"
            />
          </script>
        </wx-open-launch-weapp>
      </div>
    </div>
  </div>
</template>

<script>
import { getInfoByCode, getJSSDK, getScoreConfig, getTemplate, registerByOpenId, joinActivity } from '../../api/api'
import wx from 'weixin-js-sdk'

export default {
  name: 'FengTuoYuanActivity',
  data() {
    return {
      eno: process.env.ENV_NUM === '1' ? '138242667734' : '138799163677',
      appId: process.env.ENV_NUM === '1' ? 'wx75dda783f234b0a9' : 'wx885161c495be58a3',
      rawCode: '',
      authCode: '',
      isWxReady: false,
      isJoiningActivity: false,
      codeInfoResponse: null,
      codeInfoData: null,
      deptId: '',
      activityId: '',
      userToken: '',
      scoreConfig: null,
      shopUrl: '',
      miniAppId: '',
      miniAppOriginalId: '',
      miniAppPage: '',
      productName: '',
      productModel: '',
      rewardModalIcon: '/static/images/fty/points.png',
      rewardModalTip: '正在为您校验活动资格，请稍候',
      rewardModalTitle: '积分领取中...',
      showRewardModal: true
    }
  },
  computed: {
    queryCode() {
      return String(this.rawCode || '').slice(0, 16)
    }
  },
  mounted() {
    this.rawCode = this.$route.query.c || ''
    this.authCode = this.$route.query.wyAuthCode || ''
    this.getWxJs()
    this.initializePage()
  },
  methods: {
    setRewardModalContent(tip, title, icon) {
      this.rewardModalIcon = icon || '/static/images/fty/points.png'
      this.rewardModalTip = tip || ''
      this.rewardModalTitle = title || ''
    },
    setRewardLoadingState() {
      this.setRewardModalContent(
        '正在为您校验活动资格，请稍候',
        '积分领取中...',
        '/static/images/fty/points.png'
      )
    },
    setRewardSuccessState(title) {
      this.setRewardModalContent(
        '查询的丰驼源乳品为正品，请放心饮用！',
        title,
        '/static/images/fty/points.png'
      )
    },
    setRewardResultState(title) {
      this.setRewardModalContent(
        '查询的丰驼源乳品为正品，请放心饮用！',
        title,
        '/static/images/fty/true.png'
      )
    },
    normalizeGiftValue(giftValue) {
      if (giftValue === '' || giftValue === null || giftValue === undefined) {
        return ''
      }
      const numericGiftValue = Number(giftValue)
      if (Number.isNaN(numericGiftValue)) {
        return String(giftValue)
      }
      if (Number.isInteger(numericGiftValue)) {
        return String(numericGiftValue)
      }
      return String(numericGiftValue).replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '')
    },
    getJoinGiftValue(joinData) {
      if (Array.isArray(joinData)) {
        const numericValues = joinData
          .map(item => Number(item && item.giftValue))
          .filter(item => !Number.isNaN(item))
        if (numericValues.length > 0) {
          const totalGiftValue = numericValues.reduce((sum, item) => sum + item, 0)
          return this.normalizeGiftValue(totalGiftValue)
        }
        const fallbackItem = joinData.find(item => item && item.giftValue !== undefined && item.giftValue !== null)
        return fallbackItem ? this.normalizeGiftValue(fallbackItem.giftValue) : ''
      }
      if (joinData && joinData.giftValue !== undefined && joinData.giftValue !== null) {
        return this.normalizeGiftValue(joinData.giftValue)
      }
      return ''
    },
    async initializePage() {
      if (this.isJoiningActivity) {
        return
      }
      this.isJoiningActivity = true
      this.setRewardLoadingState()
      try {
        if (!this.queryCode) {
          this.setRewardResultState('请返回重新扫码')
          return
        }
        if (!this.authCode) {
          this.setRewardResultState('请返回重新扫码')
          return
        }
        await this.loadCodeInfo()
        if (!this.deptId) {
          this.setRewardResultState('码信息获取失败，请稍后重试')
          return
        }
        const activityId = await this.loadTemplate()
        if (!activityId) {
          this.setRewardResultState('暂无可参与的活动')
          return
        }
        const userToken = await this.registerUser()
        if (!userToken) {
          return
        }
        await this.joinCurrentActivity()
      } finally {
        this.isJoiningActivity = false
      }
    },
    async loadCodeInfo() {
      if (!this.queryCode) {
        this.deptId = ''
        this.productName = ''
        this.productModel = ''
        return
      }
      try {
        const res = await getInfoByCode(this.queryCode)
        const data = res && res.data ? res.data : null
        this.codeInfoResponse = data
        this.codeInfoData = data && data.data ? data.data : null
        this.deptId = this.codeInfoData && this.codeInfoData.deptId ? String(this.codeInfoData.deptId) : ''
        this.productName = this.codeInfoData && this.codeInfoData.productName ? this.codeInfoData.productName : ''
        this.productModel = this.codeInfoData && this.codeInfoData.productNo ? this.codeInfoData.productNo : ''
        if (this.deptId) {
          await this.loadScoreConfig()
        }
      } catch (error) {
        this.codeInfoResponse = null
        this.codeInfoData = null
        this.deptId = ''
        this.scoreConfig = null
        this.shopUrl = ''
        this.miniAppId = ''
        this.miniAppOriginalId = ''
        this.miniAppPage = ''
        this.productName = ''
        this.productModel = ''
        console.error('丰驼源活动页码信息查询失败:', error)
      }
    },
    async loadTemplate() {
      if (!this.deptId) {
        this.activityId = ''
        return ''
      }
      try {
        const res = await getTemplate(this.deptId)
        const data = res && res.data ? res.data.data : null
        this.activityId = data && data.activityId ? String(data.activityId) : ''
        return this.activityId
      } catch (error) {
        this.activityId = ''
        console.error('丰驼源活动页获取活动模板失败:', error)
        return ''
      }
    },
    async loadScoreConfig() {
      try {
        const res = await getScoreConfig(this.deptId)
        const data = res && res.data ? res.data.data : null
        this.scoreConfig = data
        this.shopUrl = data && data.shopUrl ? data.shopUrl : ''
        if (this.shopUrl) {
          const shopInfo = this.shopUrl.split('|')
          this.miniAppId = shopInfo[0] || ''
          this.miniAppOriginalId = shopInfo[1] || ''
          this.miniAppPage = shopInfo[2] || ''
        } else {
          this.miniAppId = ''
          this.miniAppOriginalId = ''
          this.miniAppPage = ''
        }
      } catch (error) {
        this.scoreConfig = null
        this.shopUrl = ''
        this.miniAppId = ''
        this.miniAppOriginalId = ''
        this.miniAppPage = ''
        console.error('丰驼源活动页获取积分配置失败:', error)
      }
    },
    async registerUser() {
      try {
        const res = await registerByOpenId(this.eno, this.authCode)
        if (res && res.data && res.data.code === '200' && res.data.data && res.data.data.token) {
          this.userToken = res.data.data.token
          return this.userToken
        }
        this.userToken = ''
        this.setRewardResultState(res && res.data && res.data.message ? res.data.message : '用户注册失败，请稍后重试')
        return ''
      } catch (error) {
        this.userToken = ''
        this.setRewardResultState('用户注册失败，请稍后重试')
        console.error('丰驼源活动页用户注册失败:', error)
        return ''
      }
    },
    async joinCurrentActivity() {
      try {
        const res = await joinActivity({
          code: this.queryCode,
          activityId: this.activityId,
          authCode: this.authCode,
          userToken: this.userToken
        })
        const responseData = res && res.data ? res.data : null
        const responseCode = responseData && responseData.code ? String(responseData.code) : ''
        if (responseCode === '200') {
          const giftValue = this.getJoinGiftValue(responseData.data)
          this.setRewardSuccessState(giftValue ? `恭喜获得${giftValue}积分` : '恭喜参与成功')
          return
        }
        if (responseCode === '500001') {
          this.setRewardResultState('积分已被领取')
          return
        }
        if (responseCode === '500004' || responseCode === '500005' || responseCode === '500006' || responseCode === '500007') {
          this.setRewardResultState(responseData && responseData.message ? responseData.message : '请稍后重试')
          return
        }
        const errorMessage = responseData && responseData.message ? responseData.message : '请稍后重试'
        this.setRewardResultState(errorMessage)
      } catch (error) {
        this.setRewardResultState('系统繁忙，请稍后重试')
        console.error('丰驼源活动页参与活动失败:', error)
      }
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app'],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideMenuItems',
            'showOptionMenu',
            'hideOptionMenu',
            'closeWindow',
            'scanQRCode'
          ]
        })
        wx.ready(() => {
          this.isWxReady = true
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          })
        })
        wx.error(err => {
          this.isWxReady = false
          console.error('活动页微信 JS-SDK 初始化失败:', err)
        })
      }).catch(err => {
        this.isWxReady = false
        console.error('活动页获取微信 JS-SDK 失败:', err)
      })
    },
    goActivity() {
      this.initializePage()
    },
    goTrace() {
      this.$router.push({
        path: '/fty/trace',
        query: {
          c: this.rawCode || this.queryCode
        }
      })
    }
  }
}
</script>

<style scoped>
.feng-tuoyuan-activity {
  height: 100vh;
  padding: clamp(10px, 2.6vw, 16px) 0 clamp(14px, 3.8vw, 20px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  overflow: hidden;
  background: rgb(76, 189, 200);
}

.success-main {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(30px, 7vw, 42px);
}

.page-header {
  display: flex;
  justify-content: center;
  width: 100%;
}

.brand-logo {
  display: block;
  width: clamp(118px, 30vw, 154px);
  height: auto;
}

.result-card-placeholder {
  width: 86vw;
  max-width: 440px;
  min-height: clamp(240px, 32vh, 320px);
  border-radius: clamp(26px, 6.5vw, 36px);
  visibility: hidden;
  pointer-events: none;
}

.success-actions {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: clamp(22px, 5vw, 34px);
}

.primary-action {
  width: 90vw;
  max-width: 460px;
}

.primary-action-img {
  display: block;
  width: 100%;
  height: auto;
}

.bottom-actions {
  width: 90vw;
  max-width: 460px;
  margin-top: clamp(12px, 3vw, 16px);
  display: flex;
  gap: clamp(10px, 2.8vw, 14px);
}

.bottom-action {
  flex: 1;
}

.bottom-action-img {
  display: block;
  width: 100%;
  height: auto;
}

.reward-modal-mask {
  position: fixed;
  inset: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
  background: rgba(8, 45, 49, 0.42);
  backdrop-filter: blur(6px);
}

.reward-modal-card {
  width: min(100%, 520px);
  border-radius: clamp(22px, 5.8vw, 30px);
  padding: clamp(34px, 8vw, 48px) clamp(18px, 5vw, 28px) clamp(28px, 7vw, 38px);
  background: linear-gradient(180deg, rgba(15, 28, 39, 0.96) 0%, rgba(9, 18, 28, 0.98) 100%);
  box-shadow: 0 20px 48px rgba(0, 31, 35, 0.28);
  color: #ffffff;
  text-align: center;
}

.reward-modal-tip {
  font-size: clamp(13px, 3.6vw, 18px);
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.94);
}

.reward-modal-icon-wrap {
  width: clamp(86px, 22vw, 124px);
  height: clamp(86px, 22vw, 124px);
  margin: clamp(26px, 6.5vw, 34px) auto 0;
  border-radius: 50%;
  background: linear-gradient(180deg, rgb(99, 204, 219) 0%, rgb(85, 193, 211) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 22px rgba(79, 196, 214, 0.26);
}

.reward-modal-icon {
  display: block;
  width: clamp(42px, 11vw, 60px);
  height: auto;
  object-fit: contain;
}

.reward-modal-title {
  margin-top: clamp(20px, 5.2vw, 28px);
  font-size: clamp(22px, 6.4vw, 32px);
  line-height: 1.2;
  font-weight: 700;
  color: #ffffff;
}

.reward-modal-info {
  margin: clamp(26px, 7vw, 36px) auto 0;
  padding: clamp(18px, 4.8vw, 22px) clamp(18px, 4.8vw, 24px);
  border-radius: clamp(16px, 4.6vw, 22px);
  background: rgba(255, 255, 255, 0.12);
  text-align: left;
}

.reward-modal-info-row {
  display: flex;
  align-items: flex-start;
  font-size: clamp(13px, 3.6vw, 17px);
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.9);
}

.reward-modal-info-label {
  flex: 0 0 auto;
  width: clamp(80px, 20vw, 102px);
}

.reward-modal-info-value {
  flex: 1;
  word-break: break-word;
}

.reward-modal-shop-entry {
  display: block;
  width: min(100%, 280px);
  margin: clamp(34px, 8vw, 46px) auto 0;
  text-align: center;
}

@media (max-height: 667px) {
  .brand-logo {
    width: 110px;
  }

  .bottom-actions {
    margin-top: 10px;
    gap: 10px;
  }

  .reward-modal-mask {
    padding: 16px;
  }

  .reward-modal-card {
    padding: 28px 16px 24px;
  }

  .reward-modal-title {
    font-size: 24px;
  }
}

@media (max-height: 568px) {
  .feng-tuoyuan-activity {
    padding: 10px 0 10px;
    justify-content: space-between;
  }

  .success-main {
    gap: 14px;
  }

  .brand-logo {
    width: 94px;
  }


  .result-card-placeholder {
    width: 84vw;
    max-width: 380px;
    min-height: 220px;
    border-radius: 24px;
  }
  .status-icon {
    width: 68px;
  }


  .status-desc {
    margin-top: 8px;
    font-size: 12px;
    line-height: 1.55;
  }

  .info-block {
    margin-top: 12px;
  }

  .info-row {
    font-size: 12px;
    line-height: 1.55;
  }

  .info-label {
    width: 76px;
  }

  .query-time {
    margin-top: 12px;
    font-size: 12px;
  }

  .primary-action {
    width: 86vw;
  }

  .bottom-actions {
    width: 86vw;
    margin-top: 8px;
    gap: 8px;
  }

  .reward-modal-card {
    padding: 20px 14px 18px;
  }

  .reward-modal-tip {
    font-size: 13px;
  }

  .reward-modal-icon-wrap {
    width: 76px;
    height: 76px;
    margin-top: 18px;
  }

  .reward-modal-icon {
    width: 38px;
  }

  .reward-modal-title {
    margin-top: 16px;
    font-size: 20px;
  }

  .reward-modal-info {
    margin-top: 18px;
    padding: 14px;
  }

  .reward-modal-info-row {
    font-size: 12px;
  }

  .reward-modal-shop-entry {
    width: 240px;
    margin: 24px auto 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FengTuoYuan/Activity.vue